import React from 'react';
import * as styles from './dualText.module.scss';
import { RichText } from '../richText/RichText';
import { SanityDualText } from '../../../../graphql-types';
import { usePageContext } from '../../../hooks/contexts/usePageContext';

interface IDualTextProps {
  dualText: SanityDualText;
}

export const DualText = ({ dualText }: IDualTextProps) => {
  const { lang } = usePageContext();
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        {dualText?.leftText ? <RichText value={dualText?.leftText?._rawText?.[lang]} /> : null}
      </div>
      <div className={styles.right}>
        {dualText.rightText ? <RichText value={dualText.rightText?._rawText?.[lang]} /> : null}
      </div>
    </div>
  );
};
